/**
 * 拆分app相关
 * */
import request from '@/utils/request';
import {
  ACTIVITY_BLUETOOTH_LIST_URL,
  APP_LIST_URL,
  DIRECT_PAY_URL,
  HOME_PROPUBLICIZE_URL,
  PAY_URL, PRO_SMS_SEND_URL,
  QUERY_ORDER_URL
} from './api-list';

// 获取拆分app的列表
export function getAppList() {
  return request({
    url: APP_LIST_URL,
    method: 'get',
    baseUrlType: 3,
    headers: {
      CLIENTECTYPE: 66
    },
  });
}

//网维助手获取图片列表
export function getProPublicize() {
  return request({
    url: HOME_PROPUBLICIZE_URL,
    method: 'get',
  });
}

//网维助手获取蓝牙模块活动
export function getActivityBluetoochList() {
  return request({
    url: ACTIVITY_BLUETOOTH_LIST_URL,
    method: 'get',
    baseUrlType: 2
  });
}

//网维助手下单
export function postDirectPay(data) {
  return request({
    url: DIRECT_PAY_URL,
    method: 'post',
    baseUrlType: 1,
    data
  });
}

//网维助手获取订单
export function getQueryOrder(params) {
  return request({
    url: QUERY_ORDER_URL,
    method: 'get',
    baseUrlType: 1,
    params
  });
}

// 短信验证码
export function proSmsSend(params) {
  return request({
    url: PRO_SMS_SEND_URL,
    method: 'post',
    params: params,
    baseUrlType: 1,
  });
}
